import { get, get1 } from './request.js'

//查询
export const getInfo = params => get('/rox/preact/lottery/info.do', params)
//改昵称
export const rename = params => get('/rox/preact/lottery/rename.do', params)
//抽卡
export const lottery = params => get('/rox/preact/lottery/lottery.do', params)
//选卡三选一
export const choice = params => get('/rox/preact/lottery/choice.do', params)
//抽到卡放背包
export const putinbag = params => get('/rox/preact/lottery/putinbag.do', params)
//完成任务
export const task = params => get('/rox/preact/lottery/task.do', params)
//查队伍里有几个人
export const teaminfo = params => get('/rox/preact/lottery/teaminfo.do', params)
//加入对方队伍
export const join = params => get('/rox/preact/lottery/join.do', params)
//查询账户下角色信息
export const getRole = params => get1("/activity/cmn/gmt/getRoleInfoByUserId.do", params);
//最终领奖到角色
export const reward = params => get("/rox/preact/lottery/reward.do", params);



